<template>
    <div>
        <zm-button size="small" @click="showCreate()" class="btn-in-line" type="primary" v-if="hasPermission">create application</zm-button>
        <zm-input size="small" placeholder="search" v-model.trim="search" class="search-input" @keyup.enter.native="fetchData()">
            <zm-button size="small" slot="append" icon="zm-icon-search" @click="fetchData()"></zm-button>
        </zm-input>
        <zm-select size="small" v-model="select" class="search-select">
            <zm-option label="appName" value="appName"></zm-option>
            <zm-option label="requestTopic" value="requestTopic"></zm-option>
            <zm-option label="responseTopic" value="responseTopic"></zm-option>
        </zm-select>
        <zm-table :init-displayed-column="initDisplayedColumn" v-loading="loading"
        :data="list.slice((pageable.page - 1) * pageable.size, pageable.page * pageable.size)">
            <zm-table-column label="App Name" prop="appName" show-overflow-tooltip></zm-table-column>
            <zm-table-column label="Request Topic" prop="requestTopic" show-overflow-tooltip>
                <template slot-scope="scope">
                    <a @click="jumpToTopic(scope.row.requestTopic)">{{ scope.row.requestTopic }}</a>
                </template>
            </zm-table-column>
            <zm-table-column label="Group" prop="group" width="120px" show-overflow-tooltip></zm-table-column>
            <zm-table-column label="Response Topic" prop="responseTopic" show-overflow-tooltip>
                <template slot-scope="scope">
                    <a @click="jumpToTopic(scope.row.responseTopic)">{{ scope.row.responseTopic }}</a>
                </template>
            </zm-table-column>
            <zm-table-column label="Tags" prop="tags">
                <template slot-scope="scope">
                    <zm-tag v-for="item in scope.row.tags" :key="item" type="" size="mini">{{ item }}</zm-tag>
                </template>
            </zm-table-column>
            <zm-table-column label="Shared Tags" prop="sharedTags">
                <template slot-scope="scope">
                    <zm-tag v-for="item in scope.row.sharedTags" :key="item" type="" size="mini">{{ item }}</zm-tag>
                </template>
            </zm-table-column>
            <zm-table-column label="DC" prop="dc" width="120px" show-overflow-tooltip></zm-table-column>
            <zm-table-column label="Created Time" prop="createdTime" :formatter="setTime" width="120px"></zm-table-column>
            <zm-table-column label="Modified Time" prop="modifiedTime" :formatter="setTime" width="120px"></zm-table-column>
            <zm-table-column prop="operation" width="110px" v-if="hasPermission">
                <template slot-scope="scope">
                    <zm-button type="icon" icon="zm-icon-edit" @click="showEdit(scope.row)"></zm-button>
                    <zm-button type="icon" icon="zm-icon-delete" @click="showDelete(scope.row.id)"></zm-button>
                </template>
            </zm-table-column>
        </zm-table>
        <div style="text-align: center" class="pagination-wrap">
            <div style="text-align: center" class="pagination-wrap">
            <zm-pagination @current-change="fetchData"
            @size-change="handleSizeChange"
                :current-page.sync="pageable.page" :page-size="pageable.size"
                layout="total, prev, pager, next, sizes"
                :page-sizes="[10, 20, 50, 100, 500, 1000]"
                :total="pageable.total">
            </zm-pagination>
        </div>
        </div>
        <zm-dialog :title="form.id ? 'Edit Application' : 'Create Application'" :visible.sync="visible">
            <zm-form ref="form" :model="form" :rules="rules" label-width="130px">
                <zm-form-item prop="appName">
                    <div slot="label">
                        <tip label="App Name" id="smart-application-appName"></tip>
                    </div>
                    <zm-select size="small" v-model="form.appName" filterable style="width: 100%">
                        <zm-option v-for="item in appList" :key="item.id" :label="item.name" :value="item.name"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item prop="clientName">
                    <div slot="label">
                        <tip label="Client Name" id="smart-application-clientName"></tip>
                    </div>
                    <zm-input size="small" v-model.trim="form.clientName"></zm-input>
                </zm-form-item>
                <zm-form-item label="dc" prop="dc">
                    <div slot="label">
                        <tip label="Dc" id="smart-application-dc"></tip>
                    </div>
                    <zm-select size="small" v-model="form.dc" clearable style="width: 100%">
                        <zm-option v-for="item in dcs" :key="item.id" :value="item.dcName" :label="item.dcName"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item prop="group">
                    <div slot="label">
                        <tip label="Group" id="smart-application-group"></tip>
                    </div>
                    <zm-input size="small" v-model.trim="form.group"></zm-input>
                </zm-form-item>
                <zm-form-item prop="ack" label-width="0">
                    <zm-checkbox v-model="form.ack">
                        <tip label="Ack" id="smart-application-ack"></tip>
                    </zm-checkbox>
                </zm-form-item>
                <zm-form-item prop="requestTopic">
                    <div slot="label">
                        <tip label="Request Topic" id="smart-application-requestTopic"></tip>
                    </div>
                    <zm-select size="small" v-model="form.requestTopic" filterable clearable allow-create default-first-option style="width: 100%">
                        <zm-option v-for="item in topicList" :key="item.id"
                            :label="item.name" :value="item.name"
                            :disabled="item.name === form.responseTopic"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item prop="responseTopic" v-if="form.ack">
                    <div slot="label">
                        <tip label="Response Topic" id="smart-application-responseTopic"></tip>
                    </div>
                    <zm-select size="small" v-model="form.responseTopic" filterable clearable allow-create default-first-option style="width: 100%">
                        <zm-option v-for="item in topicList" :key="item.id"
                            :label="item.name" :value="item.name"
                            :disabled="item.name === form.requestTopic"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item prop="tags">
                    <div slot="label">
                        <tip label="Tags" id="smart-application-tags"></tip>
                    </div>
                    <zm-checkbox-group size="small" v-model="form.tags" @change="handleTags">
                        <zm-checkbox v-for="item in tags" :key="item"
                            :label="item" :value="item"
                            :disabled="form.sharedTags.indexOf(item) > -1"></zm-checkbox>
                    </zm-checkbox-group>
                </zm-form-item>
                <zm-form-item prop="sharedTags">
                    <div slot="label">
                        <tip label="Shared Tags" id="smart-application-sharedTags"></tip>
                    </div>
                    <zm-checkbox-group size="small" v-model="form.sharedTags" @change="handleSharedTags">
                        <zm-checkbox v-for="item in tags" :key="item"
                            :label="item" :value="item"
                            :disabled="form.tags.indexOf(item) > -1"></zm-checkbox>
                    </zm-checkbox-group>
                </zm-form-item>
                <zm-form-item label-width="0px">
                    <zm-checkbox v-model="form.openSetting" @change="onOpenSettingChange">
                        <tip label="Setting" id="smart-application-openSetting"></tip>
                    </zm-checkbox>
                </zm-form-item>
                <div class="param-wrapper" v-if="form.openSetting" v-loading="form.settingLoading">
                <zm-form-item prop="strategy">
                    <div slot="label">
                        <tip label="Strategy" id="smart-application-strategy"></tip>
                    </div>
                    <zm-select size="small" v-model="form.settingParam.strategy" style="width: 100%">
                        <zm-option v-for="item in Object.keys(strategyList)" :key="item" :label="strategyList[item]" :value="item"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item prop="counts" label-width="180px">
                    <div slot="label">
                        <tip label="Counts" id="smart-application-counts"></tip>
                    </div>
                    <zm-input-number size="small" v-model="form.settingParam.counts" :min="0"></zm-input-number>
                </zm-form-item>
                <zm-form-item prop="maxWorkersPerCpu" label-width="180px">
                    <div slot="label">
                        <tip label="Max Workers Per Cpu" id="smart-application-maxWorkersPerCpu"></tip>
                    </div>
                    <zm-input-number size="small" v-model="form.settingParam.maxWorkersPerCpu" :min="0"></zm-input-number>
                </zm-form-item>
                <zm-form-item prop="receiveCounts" label-width="180px">
                    <div slot="label">
                        <tip label="Receive Counts" id="smart-application-receiveCounts"></tip>
                    </div>
                    <zm-input-number size="small" v-model="form.settingParam.receiveCounts" :min="0"></zm-input-number>
                </zm-form-item>
                <zm-form-item prop="requiredMinInstances" label-width="180px">
                    <div slot="label">
                        <tip label="Required Min Instances" id="smart-application-requiredMinInstances"></tip>
                    </div>
                    <zm-input-number size="small" v-model="form.settingParam.requiredMinInstances" :min="0"></zm-input-number>
                </zm-form-item>
                <zm-form-item label-width="0px">
                    <zm-checkbox v-model="form.settingParam.active">
                        <tip label="Active" id="smart-application-active"></tip>
                    </zm-checkbox>
                </zm-form-item>
                </div>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="visible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="save()" :loading="form.settingLoading || loading">Submit</zm-button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import { searchServicePoolApplication, createApplication, editApplication, deleteApplication, listServiceById, listStrategy, listApplication } from '@/api/smart'
import { getAllUser, getTopics, getChannelDcs } from '@/api'
import tip from 'components/ToolTip/index'
export default {
    name: 'service',
    components: {
        tip
    },
    data () {
        return {
            initDisplayedColumn: {
                key: 'smartapplication',
                props: ['appName', 'requestTopic', 'responseTopic', 'tags', 'sharedTags', 'group', 'createdTime', 'modifiedTime', 'operation']
            },
            select: 'appName',
            search: '',
            role: localStorage.role,
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            loading: false,
            serviceId: '',
            poolId: '',
            list: [],
            topicList: [],
            appList: [],
            tags: [],
            dcs: [],
            strategyList: [],
            visible: false,
            form: {
                id: '',
                appName: '',
                clientName: '',
                dc: '',
                group: '',
                ack: false,
                requestTopic: '',
                responseTopic: '',
                sharedTags: [],
                tags: [],
                serviceName: '',
                poolName: '',
                openSetting: false,
                settingLoading: false,
                settingParam: {
                    active: false,
                    counts: 0,
                    maxWorkersPerCpu: 0,
                    receiveCounts: 0,
                    requiredMinInstances: 0,
                    strategy: ''
                }
            },
            rules: {
                appName: [
                    { required: true, validator: 'please select appName', trigger: 'blur' }
                ],
                clientName: [
                    { required: true, message: 'please enter clientName', trigger: 'blur' }
                ],
                // dc: [
                //     { required: true, validator: 'please select dc', trigger: 'blur' }
                // ],
                group: [
                    { required: true, validator: 'please enter group', trigger: 'blur' }
                ],
                requestTopic: [
                    { required: true, message: 'please select requestTopic', trigger: 'blur' }
                ],
                tags: [
                    { required: true, message: 'please select tags', trigger: 'change' }
                ],
                sharedTags: [
                    { required: true, message: 'please select sharedTags', trigger: 'change' }
                ]
            },
            pageable: {
                page: 1,
                size: 10,
                total: 0
            }
        }
    },
    created () {
        this.form.serviceName = this.$route.params.serviceName
        this.form.poolName = this.$route.params.poolName
        this.serviceId = this.$route.params.serviceId
        this.poolId = this.$route.params.poolId
        this.fetchData()
        this.fetchApp()
        this.fetchTopic()
    },
    methods: {
        handleSizeChange (val) {
            this.pageable.size = val
            this.fetchData()
        },
        fetchTags () {
            listServiceById(this.serviceId).then(response => {
                this.tags = response.tags
            })
        },
        jumpToTopic (name) {
            this.$router.push({
                path: '/dashboard/topic',
                query: { name }
            })
        },
        handleTags (val) {
            if (val.length > 1) {
                this.form.tags.splice(0, 1)
            }
        },
        handleSharedTags (val) {
            if (val.length > 1) {
                this.form.sharedTags.splice(0, 1)
            }
        },
        fetchDcs () {
            this.form.dc = ''
            getChannelDcs().then(response => {
                this.dcs = response
            })
        },
        setTime (row, column, cellValue, index) {
            let time = row[column.property]
            if (time) {
                return new Date(parseInt(time)).toLocaleString()
            }
            return ''
        },
        fetchApp () {
            getAllUser().then(response => {
                this.appList = response
            })
        },
        fetchTopic () {
            getTopics().then(response => {
                this.topicList = response
            })
        },
        fetchStrategy () {
            listStrategy().then(response => {
                this.strategyList = response
            })
        },
        fetchSetting () {
            this.form.settingLoading = true
            listServiceById(this.serviceId).then(response => {
                this.form.settingParam.active = response.setting.active
                this.form.settingParam.counts = response.setting.counts
                this.form.settingParam.maxWorkersPerCpu = response.setting.maxWorkersPerCpu
                this.form.settingParam.receiveCounts = response.setting.receiveCounts
                this.form.settingParam.requiredMinInstances = response.setting.requiredMinInstances
                this.form.settingParam.strategy = response.setting.strategy
                this.form.settingLoading = false
            }).catch(() => {
                this.form.settingLoading = false
            })
        },
        onOpenSettingChange (val) {
            if (val) {
                this.fetchSetting()
            } else {
                this.form.settingParam.active = null
                this.form.settingParam.counts = null
                this.form.settingParam.maxWorkersPerCpu = null
                this.form.settingParam.receiveCounts = null
                this.form.settingParam.requiredMinInstances = null
                this.form.settingParam.strategy = null
            }
        },
        showCreate () {
            this.fetchStrategy()
            this.fetchTags()
            this.fetchDcs()
            this.form.id = ''
            this.form.appName = ''
            this.form.clientName = ''
            this.form.dc = ''
            this.form.group = ''
            this.form.requestTopic = ''
            this.form.responseTopic = ''
            this.form.ack = false
            this.form.sharedTags = []
            this.form.tags = []
            this.form.settingParam.active = null
            this.form.settingParam.counts = null
            this.form.settingParam.maxWorkersPerCpu = null
            this.form.settingParam.receiveCounts = null
            this.form.settingParam.requiredMinInstances = null
            this.form.settingParam.strategy = null
            this.form.openSetting = false
            this.visible = true
        },
        showEdit (row) {
            this.fetchStrategy()
            this.fetchTags()
            this.fetchDcs()
            this.form.id = row.id
            this.form.appName = row.appName
            this.form.clientName = row.clientName
            this.form.dc = row.dc
            this.form.group = row.group
            this.form.requestTopic = row.requestTopic
            this.form.responseTopic = row.responseTopic
            this.form.ack = row.ack
            this.form.sharedTags = row.sharedTags
            this.form.tags = row.tags
            this.form.openSetting = false
            if (row.setting) {
                this.form.settingParam.active = row.setting.active
                this.form.settingParam.counts = row.setting.counts
                this.form.settingParam.maxWorkersPerCpu = row.setting.maxWorkersPerCpu
                this.form.settingParam.receiveCounts = row.setting.receiveCounts
                this.form.settingParam.requiredMinInstances = row.setting.requiredMinInstances
                this.form.settingParam.strategy = row.setting.strategy
                this.form.openSetting = true
            }
            this.visible = true
        },
        save () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    const { id, appName, dc, clientName, group, ack, requestTopic, responseTopic, sharedTags, tags, serviceName, poolName, settingParam, openSetting } = this.form
                    const data = openSetting ? { id, appName, dc, clientName, group, ack, requestTopic, responseTopic, sharedTags, tags, serviceName, poolName, settingParam }
                    : { id, appName, dc, clientName, group, ack, requestTopic, responseTopic, sharedTags, tags, serviceName, poolName }
                    if (id) {
                        this.loading = true
                        editApplication(data).then(() => {
                            this.$message.success('Update success')
                            this.loading = false
                            this.visible = false
                            this.fetchData()
                        }).catch(() => {
                            this.loading = false
                        })
                    } else {
                        this.loading = true
                        createApplication(data).then(() => {
                            this.$message.success('Create success')
                            this.loading = false
                            this.visible = false
                            this.fetchData()
                        }).catch(() => {
                            this.loading = false
                        })
                    }
                }
            })
        },
        showDelete (id) {
            this.$confirm('This will permanently delete the application. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                deleteApplication(id).then(response => {
                    this.loading = false
                    this.fetchData()
                    this.$message({
                        message: 'Delete application success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        },
        fetchData () {
            this.loading = true
            if (this.search) {
                const data = {}
                data[this.select] = this.search
                searchServicePoolApplication(data, this.serviceId, this.poolId, this.pageable.size, this.pageable.page - 1).then(response => {
                    const { content, total } = response
                    this.list = content
                    this.pageable.total = total
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            } else {
                listApplication(this.serviceId, this.poolId, this.pageable.size, this.pageable.page - 1).then(response => {
                    const { content, total } = response
                    this.list = content
                    this.pageable.total = total
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            }
        }
    }
}
</script>
<style>
.btn-contain.zm-dropdown {
    margin: 8px;
    display: inline;
}
.btn-in-line{
    margin: 10px
}
.zm-input-group{
    width: 20%;
}
.search-input{
    float: right;
    margin: 10px;
    width: 200px;
}
.search-select {
    float: right;
    margin: 10px 0;
    width: 150px;
}
</style>
